<template>
  <div>
    <div class="bg flex flex-end">
      <el-select v-model="searchCondition.groupOwnerName" class="mr10" size="small" filterable clearable placeholder="请选择群主">
        <el-option
            v-for="item in qzList"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <el-input
          placeholder="请输入群名称"
          v-model="searchCondition.groupName"
          class="mr20"
          size="small"
          clearable>
      </el-input>
      <el-button size="small" type="primary" @click="paging(1)"
      >查询</el-button
      >
    </div>
    <hm-content class="mt10">
      <el-table
          :data="list"
          border
          stripe
          size="small"
          style="width: 100%">
        <el-table-column
            header-align="center"
            align="center"
            prop="groupName"
            label="群名称"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="groupOwnerName"
            label="群主">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="memberCount"
            label="群人数">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="todayJoinCount"
            label="今日入群">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间">
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="storeAddress"
            width="120"
            label="操作">
          <template slot-scope="scope">
            <!--<div class="flex flex-center">
              <el-button size="small" class="blue" type="text" @click="toDetail(scope.row)"
              >详情</el-button
              >
            </div>-->
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>
    </hm-content>
  </div>

</template>

<script>
import {getLoginUser} from "@/utils/auth";

export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {
        groupOwnerName: "",
        groupName:""
      },
      qzList: [],
      statusList: []
    };
  },
  created() {
    this.queryQzList();
    this.queryList();
  },
  mounted() {},
  methods: {
    //查询群主数据
    async queryQzList() {
      const { storeCode } = getLoginUser();
      let params = {
        storeCode
      };
      const formData = new FormData();
      Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
      });
      const { code, result } = await this.$store.dispatch("queryGroupOwnerList", formData);
      if (code === "0") {
       this.qzList = result;
      }
    },
    //去详情
    toDetail(row) {
      console.log(row);
      this.$router.push({
        name: 'CustomerBaseDetail'
      });
    },
    async queryList() {
      const { storeCode } = getLoginUser();
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        storeCode
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryWechatGroupList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #fff;
  padding: 20px;
}
</style>
